import axiosInstance from '@/services/axiosInstance'

async function getConfiguration (params = null) {
  const req = {
    url: 'api/config/getvalorconfiguracion',
    method: 'GET',
    headers: {
      'Content-type': 'application/json',
      'access-control-allow-origin': '*'
    },
    params,
  }
  const res = await axiosInstance(req)
  return res.data
}

export { getConfiguration }
